<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-align:center">To Professor Michael McIntyre, my best boss during my whole 54-year-old teaching career.</p><br/>
<p style="text-align:center">To my friend Miles Harvey, whose modesty and outstanding performance as best seller inspires me as an author.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?e3237fd6